<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <md-button class="md-icon-button" @click="menuVisible = !menuVisible">
          <v-icon name="bars" />
        </md-button>
        <span class="md-title">Video Hosting</span>
        <div class="md-toolbar-section-end">
          <md-button @click="logout" class="md-primary">Logout</md-button>
        </div>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <md-toolbar class="md-transparent" md-elevation="0">Menu</md-toolbar>

        <md-list>
          <router-link tag="md-list-item" exact to="/admin">
            <md-icon> <v-icon name="users" /></md-icon>
            <span class="md-list-item-text">Users</span>
          </router-link>
      
         <router-link tag="md-list-item" exact to="/admin/categories">
            <md-icon><v-icon name="list" /></md-icon>
            <span class="md-list-item-text">Categories</span>
          </router-link>

          <router-link tag="md-list-item" exact to="/admin/videos">
            <md-icon><v-icon name="video" /></md-icon>
            <span class="md-list-item-text">Videos</span>
          </router-link>

          <md-list-item md-expand>
            <md-icon> <v-icon name="bolt" /></md-icon>
            <span class="md-list-item-text">CMS</span>
            <md-list slot="md-expand">
              <router-link tag="md-list-item" exact to="/admin/footer-menu">
                <md-icon> <v-icon name="bars" /></md-icon>
                <span class="md-list-item-text">Footer Menu</span>
              </router-link>
              <router-link tag="md-list-item" exact to="/admin/content">
                <md-icon><v-icon name="book"/></md-icon>
                <span class="md-list-item-text">Content</span>
              </router-link>
            </md-list>
          </md-list-item>

          <router-link tag="md-list-item" exact to="/">
            <md-icon> <v-icon name="home" /></md-icon>
            <span class="md-list-item-text">Back to site</span>
          </router-link>
        </md-list>
      </md-app-drawer>
      <md-app-content>
        <slot />
      </md-app-content>
    </md-app>
  </div>
</template>

<script>
export default {
  name: "Overlap",
  data: () => ({
    menuVisible: false
  }),
  methods: {
    logout() {
      localStorage.removeItem("token");
      this.$router.go();
    }
  }
};
</script>

<style lang="scss" scoped>
.md-app {
  height: 100vh;
  border: 1px solid rgba(#000, 0.12);
}

.md-drawer {
  width: 230px;
  max-width: calc(100vw - 125px);
}
</style>
